import React, { Component } from 'react';
import { Card, CardBody, CardTitle } from "reactstrap";
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { trackMailApi } from '../../services/consts';
import autosize from 'autosize'
// const trackMailApiEndPoint = trackMailApi;

export default class TemplateEditor extends Component {

    // trackById = trackMailApiEndPoint + '/' + this.props.prospectID + '/photo/border.jpg';
    // console.log("trackById", trackById);
    // selectedTemplate = true;
    // html = this.props.showTemplate + "<img src="+'"'+this.props.trackMail+'"'+" style='height: auto;width: auto'";
    // html = this.props.showTemplate +this.props.trackMail + this.props.showTemplateId.id;
    // html = this.props.showTemplate;
    html = this.props.showTemplate;
    contentBlock = htmlToDraft(this.html);
    contentState = ContentState.createFromBlockArray(this.contentBlock.contentBlocks);

    // contentBlock = htmlToDraft(this.html);
    // contentState = ContentState.createFromBlockArray(this.contentBlock.contentBlocks);

    // state = {
    //     editorState: EditorState.createWithContent(this.contentState),
    //     contentData: '',
    // }
    state = {
      showTextCode:false,
      showEditorCode:true,
      editorState: EditorState.createWithContent(this.contentState),
      contentData: '',
      // editor: EditorState.createEmpty(),
      editor:EditorState.createWithContent(this.contentState),
      editorHTML: '',
      // showCode: false
    }

    // onEditorStateChange = (editorState) => {
    //     this.setState({
    //         editorState,
    //     });
    //     this.props.showContent(draftToHtml(convertToRaw(editorState.getCurrentContent())))
    // };

    onEditorStateChange = (editorState) => {
      // const editorHTML = this.props.showContent(draftToHtml(convertToRaw(editorState.getCurrentContent())))
      // this.setState({ editorState })
  
      this.setState({
        editorState,
        contentData:this.props.showContent(draftToHtml(convertToRaw(editorState.getCurrentContent())))
      });
      // this.props.showContent(draftToHtml(convertToRaw(editorState.getCurrentContent())))
    };

    onEditEditorHTML = (e) => {
      const editorHTML = e.target.value;
      this.props.showContent(editorHTML)
      let editor
      const contentBlock = htmlToDraft(editorHTML)
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
        editor = EditorState.createWithContent(contentState)
      } else {
        editor = EditorState.createEmpty()
      }
      this.setState({ editor, editorHTML })
    }
  
    toggleEditorCode = () => {
      // const { showEditorCode } = this.state
    this.setState({ showEditorCode: !this.state.showEditorCode, showTextCode: this.state.showTextCode }, () => {
      this.setState({showEditorCode: true});
      if (!this.state.showEditorCode) {
        autosize(this.textareaEditor)
        autosize.update(this.textareaEditor)
      } else {
        this.setState({showTextCode: false});
        autosize.destroy(this.textareaEditor)
      }
    })
    }

    toggleTextCode = () => {
      // const { showTextCode } = this.state
      this.setState({ showTextCode: !this.state.showTextCode, showEditorCode: this.state.showEditorCode}, () => {
        this.setState({showTextCode: true});
        if (!this.state.showTextCode) {
          autosize(this.textareaEditor)
          autosize.update(this.textareaEditor)
        } else {
          this.setState({showEditorCode: false});
          autosize.destroy(this.textareaEditor)
        }
      })
    }

    btnStyle = () => {
      if(this.state.showTextCode == true || this.state.showEditorCode == true){
        return ({marginBottom:"20px",marginTop:"20px"})
        // return ({marginBottom:"0px"})
      }else{
        return ({marginBottom:"20px",marginTop:"20px"})
        // return ({marginBottom:"0px"})
      }
    }
  
    btnHtmlSelectStyle = () => {
      if(this.state.showEditorCode == true && this.state.showTextCode == false){
          return ({border:"1px solid",borderRadius:"20px",padding:"8px", cursor:"pointer",textAlign:"center"})
      }else{
        return ({padding:"8px", cursor:"pointer",textAlign:"center"})
      }
    }
  
    btnTextSelectStyle = () => {
      if(this.state.showTextCode == true && this.state.showEditorCode == false){
          return ({border:"1px solid",borderRadius:"20px",padding:"8px", cursor:"pointer",textAlign:"center"})
      }else{
        return ({padding:"8px", cursor:"pointer",textAlign:"center"})
      }
    }

    render() {
      const ShowEditorCode = () => (
        <div className="row" style={this.btnStyle()}>
        <div className="col-2"></div>
        <div className="col-3" style={this.btnHtmlSelectStyle()}
          onClick={this.toggleEditorCode}>
          {showEditorCode ? 'HTML Editor' : 'HTML Editor'}
        </div>
        <div className="col-2"></div>
        <div className="col-3" style={this.btnTextSelectStyle()}
          onClick={this.toggleTextCode}>
          {showTextCode ? 'Text Editor' : 'Text Editor'}
        </div>
        <div className="col-2"></div>
        <br/>
        </div>
        )
        const { editor,editorHTML,showEditorCode,showTextCode,editorState } = this.state;
          
        return (
            <div className="TemplateEditor">
                <Card>
                <ShowEditorCode />
                    {/* {this.selectedTemplate == false ?  */}
                    <CardTitle className="bg-light border-bottom p-3 mb-0">Template
                    </CardTitle> 
                    {/* : <CardTitle className="bg-light border-bottom p-3 mb-0">Template &nbsp;(<span style={{opacity:"1"}}><strong>Click to Preview or Edit</strong></span>)
                    </CardTitle>} */}
                    {/* <CardBody className="" onClick={(e)=>this.selectedTemplate=false}>
                        {this.selectedTemplate == false ?  */}
                    <CardBody className="">
                      {showTextCode ? 
                      <Editor
                        editorState={editorState}
                        wrapperClassName="demo-wrapper"
                        editorClassName="demo-editor"
                        editorStyle={{height:"200px"}}
                        onEditorStateChange={this.onEditorStateChange}
                        placeholder="Add text here ..."
                      /> : "" }
                      {showEditorCode ? 
                        <Editor
                          disabled
                          editorState={editor}
                          wrapperClassName="demo-wrapper"
                          editorStyle={{height:"200px"}}
                          editorClassName="demo-editor"
                          onEditorStateChange={this.onEditorStateChange}
                        /> : "" }
                    </CardBody>
                </Card>
                {/* <Card hidden={this.selectedTemplate}> */}
                <Card>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        Preview
                    </CardTitle>
                    {showTextCode ? 
                    <textarea
                      disabled
                      value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
                    /> : ""}
                    { showEditorCode ? <textarea
                        ref={c => { this.textareaEditor = c }}
                        defaultValue={this.props.showTemplate}
                        onChange={this.onEditEditorHTML}
                      /> : "" }
                </Card>
            </div>
        );
    }
}